import { mapCollection } from '../../utils/collection.utils';
import { AverageReport } from '../average-report';

export class AverageReportBuilder {
  static fromJson(json) {
    return (json)
      ? new AverageReport(
        json.filteredPollReports,
        json.filteredCompaniesPollReports
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(AverageReportBuilder.fromJson, list) : [];
  }
}
